import { Link } from "react-router-dom";

import { breadcrumbCrumbs, getPublicPage } from "../seo/publicPages";

import "./PublicBreadcrumb.css";

type PublicBreadcrumbProps = {
  path: string;
};

/**
 * Visible trail for public content pages (Acasă › Ghiduri › articol).
 * JSON-LD for the same trail is written at prerender time.
 */
export default function PublicBreadcrumb({ path }: PublicBreadcrumbProps) {
  let crumbs;
  try {
    crumbs = breadcrumbCrumbs(getPublicPage(path));
  } catch {
    return (
      <nav className="public-breadcrumb" aria-label="Breadcrumb">
        <Link to="/" className="public-breadcrumb__link">
          ← Înapoi la pagina principală
        </Link>
      </nav>
    );
  }

  if (crumbs.length < 2) {
    return null;
  }

  return (
    <nav className="public-breadcrumb" aria-label="Breadcrumb">
      <ol className="public-breadcrumb__list">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return (
            <li key={`${crumb.path}-${index}`} className="public-breadcrumb__item">
              {index > 0 ? (
                <span className="public-breadcrumb__sep" aria-hidden="true">
                  ›
                </span>
              ) : null}
              {last ? (
                <span className="public-breadcrumb__current" aria-current="page">
                  {crumb.name}
                </span>
              ) : (
                <Link to={crumb.path} className="public-breadcrumb__link">
                  {crumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
